import {useMemo} from 'react';

export const usePriceCalculator = (selectedPasta, quantity, selectedSauceId, selectedDrinkId, sauces, drinks) => {
    return useMemo(() => {
        // Base price calculation
        const basePrice = selectedPasta ? (quantity / 100) * selectedPasta.pricePerUnit : 0;

        // Sauce price calculation
        const selectedSauce = sauces?.find(s => s.id === selectedSauceId);
        const saucePrice = selectedSauce ? selectedSauce.price : 0;

        // Drink price calculation
        const selectedDrink = drinks?.find(d => d.id === selectedDrinkId);
        const drinkPrice = selectedDrink ? selectedDrink.price : 0;

        // Total price
        const totalPrice = basePrice + saucePrice + drinkPrice;

        return {
            base: basePrice,
            sauce: saucePrice,
            drink: drinkPrice,
            total: totalPrice
        };
    }, [selectedPasta, quantity, selectedSauceId, selectedDrinkId, sauces, drinks]);
};
